import React from 'react';

import { Text } from '@mantine/core';
import { AthleteAppointmentMeta } from 'hooks/athleteAppointment/useAthleteAppointmentMeta';

interface AthleteAppointmentSupplementalTextProps {
  athleteAppointmentMeta: AthleteAppointmentMeta;
  size: 'sm' | 'md' | 'lg';
}

const AthleteAppointmentSupplementalText = ({
  athleteAppointmentMeta,
  size,
}: AthleteAppointmentSupplementalTextProps): JSX.Element => {
  return (
    <Text size={size} color={athleteAppointmentMeta.color}>
      {athleteAppointmentMeta.supplementalText}
    </Text>
  );
};

export default AthleteAppointmentSupplementalText;
